import styled from '@emotion/styled';
import TextField from '../TextField';

export const FullWidthTextField = styled(TextField)`
  width: 100%;
`;
